import type { ReactNode } from "react";
import { AnnouncementBar } from "./AnnouncementBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Grain } from "@/components/Motion/Grain";
import { CustomCursor } from "@/components/Motion/CustomCursor";
import styles from "./Layout.module.css";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.shell}>
      <CustomCursor />
      <AnnouncementBar />
      <Header />
      <main id="main" className={styles.main}>
        {children}
      </main>
      <Footer />
      <Grain />
    </div>
  );
}
